import { Button, Flex } from "antd";
import { useNavigate, useRouteError } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();
  const navigate = useNavigate();

  return (
    <Flex
      justify="center"
      align="center"
      gap={"0.5rem"}
      vertical
      className="h-screen"
    >
      <h1 className="text-2xl font-bold">Oops!</h1>
      <p className="text-xl text-center">
        Sorry, an unexpected error has occurred.
      </p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
      <Button onClick={() => navigate("/")} type="link">
        Go Back
      </Button>
    </Flex>
  );
}
